import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/** Shape stored in Redux and accepted by setSelectedPaymentMethod */
export type SelectedPaymentMethodPayload = {
  id: string;
  paymentType: string;
  title: string;
  description: string;
  subTitle: string;
  depositsAvailable: boolean;
  withdrawalsAvailable: boolean;
  minLimit: number;
  maxLimit: number;
  isBraintreeVault?: boolean;
};

export type State = {
  isModalOpen: boolean;
  type: string;
  selectedMethod: SelectedPaymentMethodPayload;
};

export const initialState: State = {
  isModalOpen: false,
  type: "deposits",
  selectedMethod: {
    id: "",
    paymentType: "",
    title: "",
    subTitle: "",
    description: "",
    depositsAvailable: false,
    withdrawalsAvailable: false,
    minLimit: 0,
    maxLimit: 10_000_000
  }
};

export type PaymentMethodSelectorTypePayload = {
  type: string;
};

const paymentMethodSelectorSlice = createSlice({
  name: "paws",
  initialState,
  reducers: {
    openPaymentMethodSelectorModal(state) {
      state.isModalOpen = true;
    },
    closePaymentMethodSelectorModal(state) {
      state.isModalOpen = false;
    },
    setPaymentMethodSelectorType(
      state,
      action: PayloadAction<PaymentMethodSelectorTypePayload>
    ) {
      state.type = action.payload.type;
    },
    setSelectedPaymentMethod(
      state,
      action: PayloadAction<SelectedPaymentMethodPayload>
    ) {
      state.selectedMethod = action.payload;
    }
  }
});

export const {
  openPaymentMethodSelectorModal,
  closePaymentMethodSelectorModal,
  setPaymentMethodSelectorType,
  setSelectedPaymentMethod
} = paymentMethodSelectorSlice.actions;

export default paymentMethodSelectorSlice.reducer;
